import UserTemplate from './template/UserTemplate'

const SysAdminPage = (props) =>{

  return (
    <>
      <UserTemplate  login={props.login}  index={3} title={"プロダクト管理者一覧"} />
    </>
  );
}

export default SysAdminPage